import { format } from "date-fns";

import { useChannel } from "@/contexts/ChannelContext";
import Typography from "@components/Typography";

import styles from "./ChannelTitle.module.css";

const ChannelTitle = () => {
  const { channel } = useChannel();

  return (
    <div>
      <Typography variant="h1">{channel?.name}</Typography>
      <p className={styles.subtitle}>
        {channel?.channel_type}, {channel?.external_source} | Last modified:{" "}
        {channel?.last_modified &&
          format(new Date(channel?.last_modified), "PP HH:mm")}
      </p>
    </div>
  );
};

export default ChannelTitle;
